import React from "react";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";

function SecretQuestionChange(props) {
  const state = props.state;

  return (
    <>
      <FormDropdown
        label="Change your first secret question"
        icon="account-check"
        id="secret_question1"
        onChange={props.handleFormFieldChange}
        // disabled
        required={state.secret_answer1 || state.secret_question2 || state.secret_answer2}
      >
        <option value="">Select an option</option>
        <option value="Mother’s maiden name">
          What is your mother’s maiden name?
          </option>
        <option value="First pet’s name">
          What was your first pet’s name?
          </option>
        <option value="Favourite movie">What is your favourite movie?</option>
      </FormDropdown>
      <FormField
        label="Answer"
        id="secret_answer1"
        name="secret-answer-1"
        placeholder="Enter Your Answer"
        value={state.secret_answer1}
        onChange={props.handleFormFieldChange}
        required={state.secret_question1 || state.secret_question2 || state.secret_answer2}
      // disabled
      />
      <FormDropdown
        label="Change your second secret question"
        icon="account-check"
        id="secret_question2"
        onChange={props.handleFormFieldChange}
        // disabled
        required={state.secret_answer1 || state.secret_question1 || state.secret_answer2}
      >
        <option value="">Select an option</option>
        <option value="Best friend’s name">
          What is your best friend’s name?
          </option>
        <option value="Favourite class type or level to teach">
          What is your favourite class type or level to teach?
          </option>
        <option value="First street">
          What was the first street where you lived?
          </option>
      </FormDropdown>
      <FormField
        label="Answer"
        id="secret_answer2"
        name="secret-answer-2"
        placeholder="Enter Your Answer"
        value={state.secret_answer2}
        onChange={props.handleFormFieldChange}
        required={state.secret_answer1 || state.secret_question1 || state.secret_question2}
      // disabled
      />
    </>
  )
}

export default SecretQuestionChange;